import loadable from '@loadable/component';

export const OrgDashboardNotificationPreferencesLoadable = loadable(
  () => import('./OrgDashboardNotificationPreferences'),
  {
    resolveComponent: (module) => module.OrgDashboardNotificationPreferences,
  },
);
